import { render } from "./FilterLoyaltyType.vue?vue&type=template&id=b34b8654"
import script from "./FilterLoyaltyType.vue?vue&type=script&lang=js"
export * from "./FilterLoyaltyType.vue?vue&type=script&lang=js"
script.render = render

export default script